import { userService } from "../services";

import config from "../config/config";

export const LoginAction = {
  fetchLoginData,
};

async function fetchLoginData(payload) {
  try {
    const apiEndpoint = config.baseUrl + config.apiName.login;
    const response = await userService.loginService(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}
